angular.module('tasks', ['core', 'files', 'document', 'clients'])
    .factory('Task', function ($resource) {
        return $resource('/crm/api/task/:id', {id: '@id'}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/task/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/task/table-statistics'},
            myTodo: {method: 'GET', isArray: false, url: '/crm/api/task/my-todo'},
            find: {method: 'GET', isArray: true},
            remove: {method: 'DELETE'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            updateTime: {method: 'POST', url: '/crm/api/task/:id/time-update'},
            updateStatus: {method: 'POST', url: '/crm/api/task/:id/status-update'},
            updatePriority: {method: 'POST', url: '/crm/api/task/:id/priority-update'},
            taskSlotCheck: {method: 'POST', url: '/crm/api/task/time-slot-check'}
        });
    })
    .factory('TaskStatus', function ($resource) {
        return $resource('/crm/api/task-status', {}, {
            list: {method: 'GET', isArray: true}
        });
    })
    .factory('ReminderTime', function ($resource) {
        return $resource('/crm/api/reminder-time', {}, {
            list: {method: 'GET', isArray: true}
        });
    })
    .service('TaskService', function ($q, $rootScope, $cookies, toastr, modals, Task) {
        this.edit = id => Task.get({id: id}, task => TaskService.editModal(task))
        this.editModal = entity => modals.open('app/task/edit-modal.tpl.html', 'TaskDialogController', entity, {size: 'lg'});
        this.showModal = id => modals.open('app/task/show-modal.html', 'TaskShowDialogController', id, {size: 'lg'}, "$ctrl");
        this.addModal = (params) => {
            let entity = {
                id: null,
                priority: "LOW",
                status: "SCHEDULED",
                clients: [],
                sendNotifications: false,
                reminders: [],
                subscriberGroups: [],
                subscribers: [],
                private: true,
                attendanceRequired: true
            };
            let group = $cookies.getObject("group-autoselect-selected");
            if (group)
                entity.subscriberGroups.push(group);

            angular.extend(entity, params);
            return this.editModal(entity);
        }
        this.clone = (id) => {
            let that = this;
            Task.get({id: id}, entity => {
                entity.id = null;
                delete entity.audit;
                delete entity.commentsCount;
                delete entity.filesCount;
                delete entity.version;
                delete entity.done;
                entity.startTime = null;
                entity.endTime = null;
                entity.realEndTime = null;
                entity.status = "SCHEDULED";

                angular.forEach(entity.reminders, reminder => reminder.id = null);
                entity.notActiveWorkers = entity.workers.filter(i => i.activated === false)
                entity.workers = entity.workers.filter(i => i.activated)
                entity.reminders = entity.reminders.filter(i => i.user.activated)
                return that.addModal(entity);
            });
        };
        this.cloneWithTime = function (id, cloneValue, clonePeriod) {
            let that = this;
            Task.get({id: id}, entity => {
                entity.id = null;
                delete entity.audit;
                delete entity.commentsCount;
                delete entity.filesCount;
                delete entity.version;
                delete entity.done;
                entity.startTime = moment(entity.startTime).add(cloneValue, clonePeriod);
                entity.endTime = moment(entity.endTime).add(cloneValue, clonePeriod);
                entity.realEndTime = null;
                entity.status = "SCHEDULED";

                angular.forEach(entity.reminders, reminder => reminder.id = null);
                entity.notActiveWorkers = entity.workers.filter(i => i.activated === false)
                entity.workers = entity.workers.filter(i => i.activated)
                entity.reminders = entity.reminders.filter(i => i.user.activated)
                return that.addModal(entity);
            });
        };
        this.remove = item => modals.confirmDelete(item.topic, () => Task.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('task.deleted')).$promise);
        this.statusChangeModal = entity => modals.open('app/task/status-change-modal.html', 'TaskStatusChangeDialogController', entity, {}, "$ctrl");
        this.timeSlotCollisionModal = slotCollisions => modals.open('app/task/time-slot-collision-modal.html', 'TimeSlotCollisionDialogController', slotCollisions, {}, "$ctrl");
        this.editPeriodModal = (id, period) => {
            let entity = {
                id: id,
                period: period
            };
            return modals.open('app/task/period-change-modal.html', 'TaskPeriodChangeDialogController', entity, {}, "$ctrl")
        };
        this.priorityChange = (id, priority) => {
            Task.updatePriority({id: id}, {priority: priority}).$promise.then(() => {
                $rootScope.$broadcast('task.updated');
                toastr.success("Ustawiono priorytet");
            });
        };
        this.updateTimeWithTimeSlotCheck = (task, periodData) => {
            let taskSlotCheckForm = {
                id: task.id,
                workers: task.workers,
                startTime: task.startTime ? moment(task.startTime) : null,
                endTime: task.endTime ? moment(task.endTime) : null
            }

            return Task.taskSlotCheck(taskSlotCheckForm).$promise
                .then(slotCollisions => {
                    if (slotCollisions.collisions === 0) {
                        return Task.updateTime({id: task.id}, periodData).$promise
                    } else {
                        return this.timeSlotCollisionModal(slotCollisions).then(() => Task.updateTime({id: task.id}, periodData).$promise)
                    }
                })
                .then(result => {
                    $rootScope.$broadcast('task.updated');
                    toastr.success("Zmieniono czas realizacji zadania");
                    return result;
                })
        };
        this.saveWithTimeSlotCheck = task => {
            let taskSlotCheckForm = {
                id: task.id,
                workers: task.workers,
                startTime: task.startTime ? moment(task.startTime) : null,
                endTime: task.endTime ? moment(task.endTime) : null
            }
            return Task.taskSlotCheck(taskSlotCheckForm).$promise
                .then(slotCollisions => {
                    if (slotCollisions.collisions === 0) {
                        return Task.save(task).$promise
                    } else {
                        return this.timeSlotCollisionModal(slotCollisions).then(() => Task.save(task).$promise)
                    }
                })
                .then(result => {
                    $rootScope.$broadcast('task.updated');
                    toastr.success("Zapisano");
                    return result;
                })
        };
        this.updateWithTimeSlotCheck = task => {
            let taskSlotCheckForm = {
                id: task.id,
                workers: task.workers,
                startTime: task.startTime ? moment(task.startTime) : null,
                endTime: task.endTime ? moment(task.endTime) : null
            }
            return Task.taskSlotCheck(taskSlotCheckForm).$promise
                .then(slotCollisions => {
                    if (slotCollisions.collisions === 0) {
                        return Task.update(task).$promise
                    } else {
                        return this.timeSlotCollisionModal(slotCollisions).then(() => Task.update(task).$promise)
                    }
                })
                .then(result => {
                    $rootScope.$broadcast('task.updated');
                    toastr.success("Zapisano");
                    return result;
                })
        };
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_TASKS",
            path: "/tasks",
            ico: "fa fa-fw fa-tasks",
            name: 'task.menu',
            order: 50
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('taskList', {
            parent: 'app',
            url: '/tasks?{page:int}&{size:int}&sort&search&periodStart&periodEnd&client&priority&status&doctype&worker&moderator&group&supervised',
            data: {
                authorities: ['ROLE_TASKS']
            },
            params: {
                doctype: {array: true, type: "int"},
                status: {array: true},
            },
            views: {
                'content@': 'taskList'
            },
            resolve: {
                statistics: (Task, $stateParams) => Task.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (Task, $stateParams) => Task.table(angular.copy($stateParams)).$promise
            }
        });
        $stateProvider.state('taskShow', {
            parent: 'app',
            url: '/task/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'taskShow'
            },
            resolve: {
                item: (Task, $stateParams) => Task.get({id: $stateParams.id}).$promise
            }
        });
        $stateProvider.state('taskShowDeprecated', {
            parent: 'app',
            url: '/tasks/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'taskShow'
            },
            resolve: {
                item: (Task, $stateParams) => Task.get({id: $stateParams.id}).$promise
            }
        });
        $stateProvider.state('taskShowAttendanceAction', {
            parent: 'app',
            url: '/task/{id}/attendance/{action}',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'taskShow'
            },
            resolve: {
                item: (Task, $stateParams) => Task.get({id: $stateParams.id}).$promise,
                action: ($stateParams) => angular.copy($stateParams.action),
                id: ($stateParams) => angular.copy($stateParams.id)
            }
        });
        $stateProvider.state('taskShowAttendanceActionDeprecated', {
            parent: 'app',
            url: '/tasks/{id}/attendance/{action}',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'taskShow'
            },
            resolve: {
                item: (Task, $stateParams) => Task.get({id: $stateParams.id}).$promise,
                action: ($stateParams) => angular.copy($stateParams.action),
                id: ($stateParams) => angular.copy($stateParams.id)
            }
        });
    });
